export default __webpack_public_path__ + "static/media/left-chevron.e79faeae.svg";